import Vue from "vue";
import {storeSearch} from "../store";
import { each, filter, flatMap } from 'lodash';

export default {
  getInstance() {
    return new Vue({
      name: "hero",
      el: ".hero",
      store: storeSearch,
      data() {
        return {
          filter: null
        };
      },
      computed: {
        searchFilter() {
          return this.$store.state.searchFilterSimple;
        }
      },
      methods: {
        update(data) {
          if (this.filter === null) this.filter = this.searchFilter;
          this.filter[data.type] = data.data;
        },
        submit(urlRoot) {
            // flatten and filter
            var items = filter(flatMap(this.filter), { selected: true });
            var ids = [];
            each(items, item => {
                each(item.selectedIds, id => ids.push(id));
            })
            var url = (ids.length > 0) ? urlRoot + "#/?id=" + ids.join("&id=") : urlRoot;
            window.location.href = url;
        }
      },
      mounted() {
        document.getElementsByTagName("body")[0].classList.add("hero--active");
        this.$store.dispatch("getSearchFilterSimple");
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/mixed-components/Hero.js